import React from "react";
import TablaProductoRetail from "js/components/TablaProductoRetail";

function ProductoRetail(props) {
  return <TablaProductoRetail />;
}

export default ProductoRetail;
